import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import UIAlert from 'UIComponents/alert/UIAlert';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';

const IE11Alert = () => {
  const [bannerOpen, setBannerOpen] = useState(false);
  useEffect(() => {
    const isIE11 = /Trident\/|MSIE/.test(window.navigator.userAgent);
    if (isIE11) setBannerOpen(true);
  }, []);

  const closeBanner = () => {
    setBannerOpen(false);
  };

  return bannerOpen && /*#__PURE__*/_jsx(UIAlert, {
    type: "warning",
    titleText: I18n.text('login.unsupported.noIeSupportBanner.header'),
    closeable: true,
    onClose: closeBanner,
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "login.unsupported.noIeSupportBanner.body"
    })
  });
};

export default IE11Alert;